import {getPivotTableConfig} from '../../utils/featureUtils'
import {
	CREATE_ABCMRESULT2_LAYOUT,
	GET_ABCMRESULT2_LAST_SET_FILTERS,
	GET_ABCMRESULT_2_PIVOT_TABLE,
	SET_ABCM2_DISPLAY_VIEW,
	SET_PIVOT_TABLE_CONFIG,
	UPDATE_ABCMRESULT2_LAST_SET_FILTERS,
} from './abcmResult2Actions'

export interface AbcmResult2 {
	data: any
	abcmDetailLoading: boolean
	pivotTableData: any
	loading: boolean
	pivotTableSourceData: any
	pivotTableUseData: any
	pivotTableConfig: any
	pivotTableMetric: any
	abcmFMData: any
	totalPages: Number
	lastSetFilters: any
}

const initialState: AbcmResult2 = {
	data: [],
	abcmDetailLoading: true,
	pivotTableData: [],
	loading: false,
	pivotTableSourceData: [],
	pivotTableUseData: [],
	pivotTableConfig: {},
	pivotTableMetric: '',
	abcmFMData: [],
	totalPages: 1,
	lastSetFilters: {},
}

export function abcmresult2Reducer(state = initialState, action: any) {
	switch (action.type) {
		case SET_PIVOT_TABLE_CONFIG:
			const pivotTableConfig = getPivotTableConfig(state.pivotTableConfig, action.response.data, action.response.metric)
			return {...state, pivotTableConfig}

		case SET_ABCM2_DISPLAY_VIEW:
			const pivotTableMetric = action.response.data
			return {...state, pivotTableMetric}

		case GET_ABCMRESULT_2_PIVOT_TABLE.triggered:
			return {...state, loading: true, abcmDetailLoading: true}
		case GET_ABCMRESULT_2_PIVOT_TABLE.succeeded:
			const response = (action.response.data || {}).abcmResultPaginated
			const data = (response || {}).entries || []
			const totalPages = response.totalPages || 1
			return {...state, loading: false, abcmDetailLoading: false, data, totalPages}
		case GET_ABCMRESULT_2_PIVOT_TABLE.failed:
			return {...state, loading: false, abcmDetailLoading: false, pivotTableData: [], data: [], totalPages: 1}
		case GET_ABCMRESULT2_LAST_SET_FILTERS.triggered:
			return {...state, loading: true}
		case GET_ABCMRESULT2_LAST_SET_FILTERS.succeeded:
			return {...state, loading: false, lastSetFilters: action.response.data}
		case GET_ABCMRESULT2_LAST_SET_FILTERS.failed:
			return {...state, loading: false, lastSetFilters: {}}
		case CREATE_ABCMRESULT2_LAYOUT.triggered:
			return {...state, loading: true}
		case CREATE_ABCMRESULT2_LAYOUT.succeeded:
			return {...state, loading: false, lastSetFilters: [action.response.data]}
		case CREATE_ABCMRESULT2_LAYOUT.failed:
			return {...state, loading: false, lastSetFilters: {}}
		case UPDATE_ABCMRESULT2_LAST_SET_FILTERS.triggered:
			return {...state, loading: true}
		case UPDATE_ABCMRESULT2_LAST_SET_FILTERS.succeeded:
			return {...state, loading: false, lastSetFilters: [action.response.data]}
		case UPDATE_ABCMRESULT2_LAST_SET_FILTERS.failed:
			return {...state, loading: false, lastSetFilters: {}}
	}
	return state
}
